"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useGetPayoutMethodsFromSelectedShop;

function useGetPayoutMethodsFromSelectedShop(shop) {
  if (!shop) {
    return [];
  }

  if (shop['payoutMethods']) {
    return (shop['payoutMethods'] || []).filter(function (item) {
      return !~['Transfer', 'TransferExchange', 'TransferAdvertising', 'Exchange', 'Chargeback'].indexOf(item['name']);
    });
  }

  return [];
}